import { getApiUrl } from "./tcApiUrl";
export function getClassifyURL() {
  const classifyurl = `${getApiUrl("classify")}`;
  return classifyurl;
}

export const getClassifyURLValue = () => {
  return getClassifyURL();
};
